import {IHttpService} from "angular";
import {Securities} from "../../../instruments/types/CodeAndExchange";

export class SecurityIndicesService {

    public static readonly id = "securityIndicesService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async asx20(): Promise<Securities> {
        const url = "/tradefloor/api/security-indices/asx20";
        const response = await this.$http.get<Securities>(url);
        return response.data;
    }
}
